import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import ImageContent from './ImageContent';
import { Container, Heading, HtmlContent } from './ui';

const StyledImageContentBlocks = styled.section`
  ${sectionMargins()};
`;

const StyledHeader = styled.header`
  text-align: center;
`;

const StyledHeading = styled(Heading)``;

const StyledContent = styled(HtmlContent)`
  margin-top: 15px;
`;

const ImageContentBlocks = ({ heading, text, items, version }) => (
  <StyledImageContentBlocks>
    <StyledHeader>
      <Container>
        <StyledHeading>{heading}</StyledHeading>
        <StyledContent content={text} />
      </Container>
    </StyledHeader>
    {items.map(({ image, heading, text, link, testimonial, flip }, id) => (
      <ImageContent
        key={id}
        image={image}
        heading={heading}
        text={text}
        link={link}
        testimonial={testimonial}
        flip={flip}
        version={version}
        isBlocks={true}
      />
    ))}
  </StyledImageContentBlocks>
);

export default ImageContentBlocks;
